import React from 'react';

const ModalContext = React.createContext();

class ModalContextProvider extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      modalJSX: (<></>),
    };
    this.setModalJSX = this.setModalJSX.bind(this);
  }

  setModalJSX(jsx) {
    this.setState({ modalJSX: jsx });
  }

  render() {
    const { children } = this.props;
    const { modalJSX } = this.state;
    return (
      <ModalContext.Provider
        value={{
          modalJSX,
          setModalJSX: this.setModalJSX,
        }}
      >
        {children}
      </ModalContext.Provider>
    );
  }
}

const connectModalContainerContextToComponent = (Component) => (props) => (
  <ModalContext.Consumer>
    {(context) => {
      if (typeof context === 'undefined') {
        throw new Error(`modalcontext not available when rendering ${Component.name}.`);
      }
      return (
        <Component
          {...props}
          setModalJSX={context.setModalJSX}
          modalJSX={context.modalJSX}
        />
      );
    }}
  </ModalContext.Consumer>
);

export default ModalContextProvider;

export { ModalContextProvider, connectModalContainerContextToComponent };
